import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UserClient, UserProfession, UserProfile, UserRoleTypes, WorkingGroups } from "src/app/web-api-client";
import { UserCreationComponent } from "../user-creation/user-creation.component";
import { EmployeeService } from "src/app/services/employee.service";
import { UserEditComponent } from "../user-edit/user-edit.component";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserModel } from "src/app/models/user.model";
import Swal from "sweetalert2";

export interface User {
  id:number;
  firstName: string;
  lastName: string;
  role: UserRoleTypes;
  organization: string;
  organizationId: number;
  idWorkingGroup: number;
  email: string;
  egn?: string;
  isService?: boolean;
  workingGroups: WorkingGroups;
  userProfessionIdUserProfession: number;
  userProfession: UserProfession;
}


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class UsersComponent implements OnInit {
  private selectedUser: User;

  public isLoaded:boolean = false;
  public users: User[];
  public searchQuery: string = '';
  public filteredUsers: User[] = [];
  public searchFiltersToggled = false;

  constructor(
    private readonly changeDetectionRef: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly employeeService:EmployeeService,
    public userClient:UserClient
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  public onUserDeleteBtnClicked(user: User) {
    this.deleteUser(user);
  }

  public onUserEditBtnClicked(user: User) {
    this.onUserEdit(user);
  }

  public onFilterUsersList(searchQuery: string) {
    this.searchQuery = searchQuery;
    this.filterUsers();
  }

  public toggleSearchFilters() {
    this.searchFiltersToggled = !this.searchFiltersToggled;
    this.changeDetectionRef.detectChanges();
  }

  public onClearFiltersClicked() {
    this.resetSearchFilter();
    this.changeDetectionRef.detectChanges();
  }

  private loadData() {
    this.employeeService.getAllUsers().subscribe((users: User[]) => {
      this.isLoaded = false;
      this.users = users;
      this.filteredUsers = users.slice();
      this.isLoaded = true;
      this.changeDetectionRef.detectChanges();
    });
  }

  public filterUsers() {
    if (this.searchQuery) {
      this.filteredUsers = this.users.filter(user =>
        user.firstName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        user.lastName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        user.email.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        user.organization.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredUsers = this.users;
    }
  }

  public onUserSelected(userProfile: User) {
    this.selectedUser = this.isSelected(userProfile) ? null : userProfile;
  }

  public isSelected(userProfile:User): boolean{
    return this.selectedUser == userProfile;
  }

  public onUserCreation():void{
    const modalRef = this.modalService.open(UserCreationComponent, {});
    modalRef.componentInstance.onClose.subscribe(r => {
      this.loadData();
    });
  }

  public deleteUser(user: User): void {
    Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    }).fire({
      title: `Внимание`,
      text: `Сигурни ли сте, че искате да изтриете този потребител?`,
      showCancelButton: true,
      confirmButtonText: 'Да',
      cancelButtonText: 'Отказ',
      showLoaderOnConfirm: true,
      reverseButtons: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        return new Promise((resolve) => {
          this.userClient.removeUser(user.id).subscribe(r => {
            resolve(r);
          });
        })
      }
    }).then((result: any) => {
      if (result.isConfirmed && result.value) {
        this.users = this.users.filter(u => u.id !== user.id);
        this.filteredUsers = this.filteredUsers.filter(u => u.id !== user.id);
        this.selectedUser = null;

        this.changeDetectionRef.detectChanges();
        Swal.fire({
          text: 'Потребителя беше успешно изтрит!',
          icon: 'success'
        });
      }
    });

    // const modalRef = this.modalService.open(ConfirmModalComponent);
    // modalRef.componentInstance.onClose.subscribe(result => {
    //   if (result) {
    //     this.userClient.removeUser(this.selectedUser.id).subscribe(r => {
    //       this.modalService.open(SuccessModalComponent);
    //     })
    //   } else {
    //     this.modalService.open(UnSuccessModalComponent);
    //   }
    // });
  }

  public GetWorkingGroup(employee:User): string {
    const flag = employee && employee.workingGroups && employee.idWorkingGroup && employee.idWorkingGroup > 0;
    return flag ? employee.workingGroups.title : 'N/A';
  }

  public onUserEdit(user: User): void {
   let modalref= this.modalService.open(UserEditComponent);
    modalref.componentInstance.editUser = user;
    modalref.componentInstance.onClose.subscribe(r => {
      this.loadData();
    })
  }

  private resetSearchFilter() {
    this.searchQuery = '';
    this.filteredUsers = this.users.slice();
  }
}
